import Loading from "../components/layout/Loading.js";
import axios from 'axios';
// import Alert from "../components/layout/Alert.js";
import $cookies from 'vue-cookies'
import Alert from "@/components/layout/Alert";


const base_url = process.env.VUE_APP_BASE_URL + "/api";

export default {
    name: "ApiRequest",
    init(authInstance) {
        this.auth = authInstance;
    },

    getHeader() {
        return {
            Authorization: 'Bearer ' + $cookies.get('token'),
        }
    },

    validateStatus(status) {
        return status === 200;
    },


    get({url = null, uri, params = {}, loadingE = 'body'}) {
        let $this = this;
        Loading.show({element: loadingE, message: 'Đang nhận dữ liệu...'});
        return axios.get((url ?? base_url) + uri, {
            headers: $this.getHeader(),
            params: params,
            validateStatus: this.validateStatus,
        }).catch(function (error) {
            Loading.hide({element: loadingE})
            $this.handError(error)
            throw error
        }).then(function (result) {
            Loading.hide({element: loadingE})
            if (result) {
                if (result.status === 200) {
                    return new Promise((resolve) => {
                        resolve(result.data.data);
                    });
                }
            }
        });
    },
    post({uri, data, loadingE = 'body'}) {
        Loading.show({element: loadingE, message: 'Đang gửi dữ liệu...'});
        let $this = this;
        return axios.post(base_url + uri, data, {
            headers: $this.getHeader(),
            validateStatus: this.validateStatus
        }).catch(function (error) {
            Loading.hide({element: loadingE})
            $this.handError(error)
            throw error
        }).then(function (result) {
            Loading.hide({element: loadingE})
            if (result) {
                if (result.status === 200) {
                    return new Promise((resolve) => {
                        resolve(result.data.data);
                    });
                }
            }
        });
    },
    put({url = null, uri, data = [], loadingE = 'body'}) {
        Loading.show({element: loadingE, message: 'Đang gửi dữ liệu...'});
        let $this = this;
        return axios.put((url ?? base_url) + uri, data, {
            headers: $this.getHeader(),
            validateStatus: this.validateStatus
        }).catch(function (error) {
            Loading.hide({element: loadingE})
            $this.handError(error)
            throw error
        }).then(function (result) {
            Loading.hide({element: loadingE})
            if (result) {
                if (result.status === 200) {
                    return new Promise((resolve) => {
                        resolve(result.data.data);
                    });
                }
            }
        });
    },
    delete({url = null, uri, data = null, loadingE = 'body'}) {
        Loading.show({element: loadingE, message: 'Đang gửi yêu cầu...'});
        let $this = this;
        return axios.delete((url ?? base_url) + uri, {
            headers: $this.getHeader(),
            validateStatus: this.validateStatus,
            data: data
        }).catch(function (error) {
            Loading.hide({element: loadingE})
            $this.handError(error);
            throw error;
        }).then(function (result) {
            Loading.hide({element: loadingE})
            if (result) {
                if (result.status === 200) {
                    return new Promise((resolve) => {
                        resolve(result.data.data);
                    });
                }
            }
        });
    },

    handError(e) {
        const errorMessage = " - " + (e.response?.data?.message || 'Lỗi không xác định. Vui lòng liên hệ bộ phận kỹ thuật');
        const status_code = e.status ?? e.response.status;
        if (status_code === 400) {
            Alert.warning({message: errorMessage, title: 'Kiểm tra dữ liệu:'});
        } else if (status_code === 422) {
            Alert.alertInvalid(e.response.data);
        } else if (status_code === 401) {
            this.auth.logout();
        } else {
            Alert.error({message: errorMessage, title: 'Có lỗi:'});
        }
    }
    // alertFail(error) {
    //     let message
    //     if (error.response) {
    //         switch (error.response.status) {
    //             case 401:
    //                 window.location.href = '/login?redirect=' + window.location.pathname;
    //                 break;
    //             case 500:
    //                 message = 'Lỗi bất thường. Liên hệ quản trị viên!';
    //                 break;
    //             case 403:
    //                 message = error.response.data.message;
    //                 break;
    //             default:
    //                 message = error.response.data.message;
    //         }
    //     } else {
    //         message = `Có lỗi: ` + error.message;
    //     }
    //     Alert.success({message:message});
    // }


}
